import * as FiscalYearRollingDateOptionsValues from 'customer-data-filters-ui/filterQueryFormat/rollingDates/FiscalYearRollingDateOptionsValues';
import { RollingDateOptionsOrdered } from 'customer-data-filters-ui/filterQueryFormat/rollingDates/RollingDateOptionsOrdered';
import { Seq } from 'immutable';
import I18n from 'I18n';
import RollingDateConfig from 'customer-data-filters-ui/filterQueryFormat/rollingDates/RollingDateConfig';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import memoize from 'transmute/memoize';
import { jsx as _jsx } from "react/jsx-runtime";
const createRollingDateOptions = memoize(isFiscalYearEnabled => Seq(RollingDateOptionsOrdered).filterNot(option => {
  return (
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    !isFiscalYearEnabled && FiscalYearRollingDateOptionsValues[option.value]
  );
}).map(option => ({
  help: I18n.text(option.helpToken),
  text: I18n.text(option.textToken),
  value: option.value
})).toArray());
const FilterOperatorRollingDateRangeInput = props => {
  const {
    condition,
    isFiscalYearEnabled,
    error,
    onChange
  } = props;
  const options = createRollingDateOptions(isFiscalYearEnabled);
  const isError = error.get('error');
  const errorMessage = error.get('message');
  const handleChange = evt => {
    const newValue = RollingDateConfig.fromRollingDateOptionValue(evt.target.value);
    onChange(syntheticEvent(condition.set('value', newValue)));
  };
  const rollingDateOptionValue = RollingDateConfig.toRollingDateOptionValue(condition.value);
  return /*#__PURE__*/_jsx(UIFormControl, {
    "aria-label": I18n.text('customerDataFiltersUI.customerDataFilters.FilterOperatorInput.ariaLabel'),
    error: isError,
    validationMessage: errorMessage,
    children: /*#__PURE__*/_jsx(UISelect, {
      onChange: handleChange,
      options: options,
      value: rollingDateOptionValue
    })
  });
};
export default FilterOperatorRollingDateRangeInput;